import React, { useCallback } from 'react';
import { Typography } from '@fuxi/eevee-ui';
import { uniqueId } from 'lodash-es';

const { Text } = Typography;

const EllipsisMiddle: React.FC<{ suffixCount: number; text: string }> = ({ suffixCount, text }) => {
  const getStartSuffix = useCallback(() => {
    if (text.length <= suffixCount) {
      return { start: text, suffix: '' };
    }
    const start = text.slice(0, text.length - suffixCount).trim();
    const suffix = text.slice(-suffixCount).trim();
    return {
      start,
      suffix,
    };
  }, [text, suffixCount]);
  return (
    <Text style={{ maxWidth: '100%' }} ellipsis={{ suffix: getStartSuffix().suffix }} key={uniqueId()}>
      {getStartSuffix().start}
    </Text>
  );
};

export default EllipsisMiddle;
